import { render, staticRenderFns } from "./BindDTQModal.vue?vue&type=template&id=5052509c&scoped=true"
import script from "./BindDTQModal.vue?vue&type=script&lang=js"
export * from "./BindDTQModal.vue?vue&type=script&lang=js"
import style0 from "./BindDTQModal.vue?vue&type=style&index=0&id=5052509c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052509c",
  null
  
)

export default component.exports